const issuer = import.meta.env.VITE_ZITADEL_ISSUER ?? "";
const clientId = import.meta.env.VITE_ZITADEL_CLIENT_ID ?? "";
const apiUrl = import.meta.env.VITE_DEB_API_URL ?? "";
const orgId = import.meta.env.VITE_ZITADEL_ORG_ID ?? "";
const orgDomain = import.meta.env.VITE_ZITADEL_ORG_DOMAIN ?? "";
const projectId = import.meta.env.VITE_ZITADEL_PROJECT_ID ?? "";
const applicationId = import.meta.env.VITE_ZITADEL_APPLICATION_ID ?? "";

export const config = {
  zitadelIssuer: issuer.replace(/\/$/, ""),
  zitadelClientId: clientId,
  zitadelApplicationId: applicationId,
  zitadelOrgId: orgId,
  zitadelOrgDomain: orgDomain,
  zitadelProjectId: projectId,
  debApiUrl: apiUrl.replace(/\/$/, ""),
  appUrl: (import.meta.env.VITE_APP_URL ?? "").replace(/\/$/, "") || undefined,
};

export function isAuthConfigured(): boolean {
  return Boolean(config.zitadelIssuer && config.zitadelClientId);
}

export function isApiConfigured(): boolean {
  // Dev: empty URL uses Vite proxy (same-origin /api). Prod build requires explicit URL.
  if (import.meta.env.DEV) return true;
  return Boolean(config.debApiUrl);
}

/** API base; empty string = same-origin (Vite dev proxy). */
export function debApiBase(): string {
  return config.debApiUrl;
}

/** OIDC scopes; org scope pins login to the Connect organisation when set. */
export function zitadelScopes(): string {
  const scopes = ["openid", "profile", "email", "offline_access"];
  if (config.zitadelOrgDomain) {
    scopes.push(`urn:zitadel:iam:org:domain:primary:${config.zitadelOrgDomain}`);
  } else if (config.zitadelOrgId) {
    scopes.push(`urn:zitadel:iam:org:id:${config.zitadelOrgId}`);
  }
  // Required for deb-api token introspection (API must be audience of the access token).
  if (config.zitadelProjectId) {
    scopes.push(`urn:zitadel:iam:org:project:id:${config.zitadelProjectId}:aud`);
  }
  return scopes.join(" ");
}

export function appOrigin(): string {
  if (config.appUrl) return config.appUrl;
  if (typeof window !== "undefined") return window.location.origin;
  return "http://localhost:3000";
}

export function redirectUri(): string {
  return `${appOrigin()}/auth/callback`;
}